export const PRODUCT_UPC_PICKER_LOADING = 'PRODUCT_UPC_PICKER_LOADING';
export const PRODUCT_UPC_PICKER_SELECT = 'PRODUCT_UPC_PICKER_SELECT';
export const PRODUCT_UPC_PICKER_ERROR = 'PRODUCT_UPC_PICKER_ERROR';
export const PRODUCT_UPC_PICKER_DATA = 'PRODUCT_UPC_PICKER_DATA';